export const Validate = (data) => {
    let errors = {}

    if (data.name === "") errors.name = "Name is required"
    else if (!/^[A-Za-z\s]*$/.test(data.name)) errors.name = "Name must contain only alphabets"

    // if (data.email === "") errors.email = "Email is required"
    // else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) errors.email = "Email is invalid"

    const numberRegex = /^[0-9+()\-\s]*$/

    if (data.contactuae === "") errors.contactuae = "Contact No. is required"
    else if (!numberRegex.test(data.contactuae)) errors.contactuae = "Contact No. is invalid"

    if (data.contacthome && !numberRegex.test(data.contacthome)) errors.contacthome = "Home Contact No. is invalid"
    if (data.emergencycontactuaeno && !numberRegex.test(data.emergencycontactuaeno)) errors.emergencycontactuaeno = "Emergency Contact No. (UAE) is invalid"
    if (data.emergencycontacthomeno && !numberRegex.test(data.emergencycontacthomeno)) errors.emergencycontacthomeno = "Emergency Contact No. (Home Country) is invalid"
    if (data.companysimnumber && !numberRegex.test(data.companysimnumber)) errors.companysimnumber = "Company SIM No. is invalid"

    if (data.dob === "") errors.dob = "Date of Birth is required"
    if (data.age === "") errors.age = "Age is required"
    else if (Number(data.age) < 18) errors.age = "Employee must be at least 18 years old"
    if (data.nationality === "") errors.nationality = "Nationality is required"
    if (data.gender === "") errors.gender = "Gender is required"
    // if (data.maritalstatus === "") errors.maritalstatus = "Marital Status is required"

    if (data.basicsalary && !numberRegex.test(data.basicsalary)) errors.basicsalary = "Basic Salary is invalid"
    if (data.housingallowance && !numberRegex.test(data.housingallowance)) errors.housingallowance = "Housing Allowance is invalid"
    if (data.transportallowance && !numberRegex.test(data.transportallowance)) errors.transportallowance = "Tranport Allowance is invalid"
    if (data.foodallowance && !numberRegex.test(data.foodallowance)) errors.foodallowance = "Food Allowance is invalid"
    if (data.mobileallowance && !numberRegex.test(data.mobileallowance)) errors.mobileallowance = "Mobile Allowance is invalid"
    if (data.otherallowance && !numberRegex.test(data.otherallowance)) errors.otherallowance = "Other Allowance is invalid"
    if (data.contractsalary && !numberRegex.test(data.contractsalary)) errors.contractsalary = "Actual Salary is invalid"

    return errors
}
